import { ReactNode } from 'react';

import { ReportsMessage } from '../../../types/SpecificReportMessage';
import { CustomerSpecificStatisticsMessage } from '../../../types/StatisticsMessage';
import { DynamicFilterContainer, Filter } from '../../cdl/Filter/DynamicFilterContainer/DynamicFilterContainer';
import { FilterMultiSelectFull } from '../../cdl/Filter/FilterMultiSelectFull/FilterMultiSelectFull';
import { translate } from '../../common/helpers/translate.helper';

interface VesselsTabFilterProps {
    allEntries: CustomerSpecificStatisticsMessage['vessel'];
    children: (filteredEntries: CustomerSpecificStatisticsMessage['vessel']) => ReactNode;
}

export const VesselsTabFilter = ({ children, allEntries }: VesselsTabFilterProps) => {
    const vesselFilter: Filter<string, ReportsMessage> = {
        filterFn: (values, entry) => {
            return values.includes(entry.context.id);
        },
        component: (values, setValues) => {
            const availableOptions = Array.from(new Set(allEntries.map((entry) => entry.context.id))).map(
                (vesselId) => ({
                    label: allEntries.find((entry) => entry.context.id === vesselId)?.context.name ?? '',
                    value: vesselId,
                })
            );

            return (
                <FilterMultiSelectFull
                    options={availableOptions}
                    values={values}
                    onChange={setValues}
                    label={translate('reporting.filter.vessel.title')}
                    filterByLabel={translate('reporting.filter.vessel.filterByVessel')}
                    filterPlaceholder={translate('reporting.filter.vessel.searchForVessel')}
                />
            );
        },
    };

    return (
        <DynamicFilterContainer allEntries={allEntries} filters={{ vessel: vesselFilter }}>
            {children}
        </DynamicFilterContainer>
    );
};
